import { CurrencyUtils } from '@Core/Currencies/CurrencyUtils';
import { GameComponent } from '@Core/GameComponent/GameComponent';
import { GameScene } from '@Core/GameScene/GameScene';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import { Logger, LoggerLevel, LoggerSource } from '@Managers/Logger';
import { WeightedBag } from '@Tools/WeightedBag';

export class LockAndRollCoinValues extends GameComponent {
    private weightedBag: WeightedBag<string>;
    private lockAndRollWeightedBag: WeightedBag<string>;
    constructor(public readonly scene: GameScene) {
        super(scene);
        Logger.log(LoggerLevel.Constructor, { class: LockAndRollCoinValues.name, source: LoggerSource.Game, message: 'LockAndRollCoinValues constructor' });
    }

    public onInit(): void {
        this.weightedBag = new WeightedBag(this.gameStore.get(EGameStoreKeys.LockAndRoll).multiplierWeights);
        if (this.gameStore.get(EGameStoreKeys.LockAndRoll).multiplierWeightsLockAndRoll)
            this.lockAndRollWeightedBag = new WeightedBag(this.gameStore.get(EGameStoreKeys.LockAndRoll).multiplierWeightsLockAndRoll!);
    }

    public getRandomCoinValue(): string {
        const isLockAndRollMode = this.gameStore.get(EGameStoreKeys.IsLockAndRollMode);
        const bet = this.gameStore.get(EGameStoreKeys.BetState).value.raw;
        const weightedBag = isLockAndRollMode && this.lockAndRollWeightedBag ? this.lockAndRollWeightedBag : this.weightedBag;
        const value = +weightedBag.draw() * bet;
        return CurrencyUtils.formatRawCurrencyValue(value, { withSymbol: false });
    }

    public getRealCoinValue(reelIndex: number, symbolIndex: number): string {
        const symbols = this.gameStore.get(EGameStoreKeys.LockAndRoll).symbols;
        const coin = symbols.find((symbol) => symbol.reel === reelIndex && symbol.index === symbolIndex - 1);
        if (!coin) return '';

        return CurrencyUtils.formatRawCurrencyValue(coin.win, { withSymbol: false });
    }

    public onCreate(): void {}
}
